export enum DialogIds {
  AboutDialog = 'AboutDialog',
  AddTeamModelDialog = 'AddTeamModelDialog',
  AssignUserRoleDialog = 'AssignUserRoleDialog',
  BookmarkAccessDialog = 'BookmarkAccessDialog',
  ClipboardDialog = 'ClipboardDialog',
  ConfirmDialog = 'ConfirmDialog',
  ContactDialog = 'ContactDialog',
  GroupRestrictionDialog = 'GroupRestrictionDialog',
  ImageDialog = 'ImageDialog',
  ImportDialog = 'ImportDialog',
  JoinDomainDialog = 'JoinDomainDialog',
  LimitDialog = 'LimitDialog',
  ManageDialog = 'ManageDialog',
  PremiumContentDialog = 'PremiumContentDialog',
  PricingDialog = 'PricingDialog',
  ProfileDialog = 'ProfileDialog',
  QuizSettingsDialog = 'QuizSettingsDialog',
  SaveAsBookmarkDialog = 'SaveAsBookmarkDialog',
  SaveBookmarkDialog = 'SaveBookmarkDialog',
  SaveModuleDialog = 'SaveModuleDialog',
  TransferUserContentDialog = 'TransferUserContentDialog',
  RemoveUserDialog = 'RemoveUserDialog',
  MergeModuleDialog = 'MergeModuleDialog',
  MergeConflictDialog = 'MergeConflictDialog',
  WelcomeTourDialog = 'WelcomeTourDialog',
  TrialExpiredDialog = 'TrialExpiredDialog',
  PremiumAccessDialog = 'PremiumAccessDialog',
  ConfirmRoleDialog = 'ConfirmRoleDialog',
  CollectionNameDialog = 'CollectionNameDialog',
}
